import {connect} from 'react-redux'
import KibanaDialog from "../../Components/Toolbars/TopToolbar/KibanaDialog/KibanaDialog";

const mapStateToProps = (store) => {
    if (store.businessReducer.business.kibanaUrl)
        return {kibanaUrl: store.businessReducer.business.kibanaUrl};

    return {};
};

const KibanaDialogContainer = connect(mapStateToProps)(KibanaDialog);

export default KibanaDialogContainer;